import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./Home.css";

const Home = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="mag-home-hero">
      <div className="mag-container">

        <div className="mag-home-grid">

          <div className="mag-home-content">
            <header className="mag-home-header">
              <span className="mag-label animate-fade-up">
                Din mäklare Åhus & österlen
              </span>
              <h1 className="mag-home-title animate-fade-up delay-1">
                {t("heroTitle") || "Ett nytt kapitel i exklusivt boende"}
              </h1>
            </header>

            <div className="mag-home-footer animate-fade-up delay-2">
              <p className="mag-home-subtitle">
                {t("heroSubtitle") || "Vi kuraterar Skånes mest unika hem med ett öga för detaljer och en passion för arkitektur."}
              </p>

        
            </div>
          </div>

          <div className="mag-home-visual">
            <div className="mag-home-image-frame animate-image-reveal">
              <div className="mag-home-image-bg"></div>
              <div className="mag-image-tint"></div>
            </div>


          </div>

        </div>
      </div>
    </section>
  );
};

export default Home;